import Modal from 'react-bootstrap/Modal'
import { useEffect } from 'react'

type PropTypes = {
  show: boolean
  close: () => void
}

const DownloadCompanionModal = ({ show, close }: PropTypes) => {
  const isWindows = navigator.userAgent.indexOf('Win') !== -1
  const winUrl =
    'https://nautilus.reasonstudios.com/latest_companion_installer/win/'
  const macUrl =
    'https://nautilus.reasonstudios.com/latest_companion_installer/mac/'

  const hasDismissedPoppup = JSON.parse(
    localStorage.getItem('dismissed_companion_poppup') || 'false'
  )

  function dismissPopup() {
    localStorage.setItem('dismissed_companion_poppup', 'true')
    close()
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (['Escape', 'Esc'].includes(event.key)) {
      dismissPopup()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, false)

    return () => {
      document.removeEventListener('keydown', handleKeyDown, false)
    }
  })

  return (
    <Modal show={show && !hasDismissedPoppup} size="xl" centered>
      <Modal.Header>
        <Modal.Title>Download the companion app</Modal.Title>
        <button type="button" className="close" onClick={() => dismissPopup()}>
          <span aria-hidden="true">×</span>
          <span className="sr-only">Close</span>
        </button>
      </Modal.Header>
      <Modal.Body bsPrefix="text-center">
        <div>
          <img
            src={'/companion-screenshot-big.png'}
            alt="companion screenshot"
            width="90%"
          />
        </div>
        <div className="mt-15 mx-30">
          It looks like you haven&apos;t got the Reason Companion installed
          yet. Install it now to get started with Reason+.
        </div>
      </Modal.Body>
      <Modal.Footer bsPrefix="align-items-center my-30">
        <div className="d-flex flex-column align-items-center">
          <div>
            <a
              href={isWindows ? winUrl : macUrl}
              className="btn btn-light text-nowrap"
            >
              <i className={`fa fa-${isWindows ? 'windows' : 'apple'}`}>
                &nbsp;&nbsp;
              </i>
              Download for {isWindows ? 'Windows' : 'Mac'}
            </a>
          </div>
          <div>
            <a href={isWindows ? macUrl : winUrl} className="text-small">
              Download for {isWindows ? 'Mac' : 'Windows'}
            </a>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
export default DownloadCompanionModal
